import axiosInstance from "./axiosInstance";

// ==================== TASKS ====================

export const createTask = async (taskData) => {
    const response = await axiosInstance.post("/workflow/tasks", taskData);
    return response.data;
};

export const getTasks = async (filters = {}) => {
    const cleanFilters = {};
    Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
            cleanFilters[key] = filters[key];
        }
    });

    const params = new URLSearchParams();
    Object.keys(cleanFilters).forEach(key => {
        if (Array.isArray(cleanFilters[key])) {
            cleanFilters[key].forEach(val => params.append(key, val));
        } else {
            params.append(key, cleanFilters[key]);
        }
    });

    const url = params.toString() ? `/workflow/tasks?${params.toString()}` : `/workflow/tasks`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const getTask = async (taskId) => {
    const response = await axiosInstance.get(`/workflow/tasks/${taskId}`);
    return response.data;
};

export const updateTask = async (taskId, taskData) => {
    const response = await axiosInstance.put(`/workflow/tasks/${taskId}`, taskData);
    return response.data;
};

export const deleteTask = async (taskId) => {
    const response = await axiosInstance.delete(`/workflow/tasks/${taskId}`);
    return response.data;
};

export const moveTask = async (taskId, columnId, position) => {
    const response = await axiosInstance.put(`/workflow/tasks/${taskId}/move`, { columnId, position });
    return response.data;
};

export const assignTask = async (taskId, assignedToId) => {
    const response = await axiosInstance.put(`/workflow/tasks/${taskId}/assign`, { assignedToId });
    return response.data;
};

export const getTaskHistory = async (taskId) => {
    const response = await axiosInstance.get(`/workflow/tasks/${taskId}/logs`);
    return response.data;
};

// ==================== COLUMNS ====================

export const getColumns = async () => {
    const response = await axiosInstance.get("/workflow/columns");
    return response.data;
};

export const createColumn = async (columnData) => {
    const response = await axiosInstance.post("/workflow/columns", columnData);
    return response.data;
};

export const updateColumn = async (columnId, columnData) => {
    const response = await axiosInstance.put(`/workflow/columns/${columnId}`, columnData);
    return response.data;
};

export const deleteColumn = async (columnId) => {
    const response = await axiosInstance.delete(`/workflow/columns/${columnId}`);
    return response.data;
};

export const reorderColumns = async (columnIds) => {
    const response = await axiosInstance.put("/workflow/columns/reorder", { columnIds });
    return response.data;
};

// ==================== COMMENTS ====================

export const getComments = async (taskId) => {
    const response = await axiosInstance.get(`/workflow/tasks/${taskId}/comments`);
    return response.data;
};

export const createComment = async (taskId, content, imageData = null, imageName = null, imageMimeType = null) => {
    const response = await axiosInstance.post(`/workflow/tasks/${taskId}/comments`, { content, imageData, imageName, imageMimeType });
    return response.data;
};

export const updateComment = async (commentId, content) => {
    const response = await axiosInstance.put(`/workflow/comments/${commentId}`, { content });
    return response.data;
};

export const deleteComment = async (commentId) => {
    const response = await axiosInstance.delete(`/workflow/comments/${commentId}`);
    return response.data;
};

// ==================== ATTACHMENTS ====================

export const getAttachments = async (taskId) => {
    const response = await axiosInstance.get(`/workflow/tasks/${taskId}/attachments`);
    return response.data;
};

export const uploadAttachment = async (taskId, attachmentData) => {
    const response = await axiosInstance.post(`/workflow/tasks/${taskId}/attachments`, attachmentData);
    return response.data;
};

export const deleteAttachment = async (attachmentId) => {
    const response = await axiosInstance.delete(`/workflow/attachments/${attachmentId}`);
    return response.data;
};

// window.open can't send Authorization headers — token in URL is intentional for file downloads
export const downloadAttachment = (attachmentId) => {
    const token = localStorage.getItem("token");
    const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:9000";
    window.open(
        `${API_URL}/workflow/attachments/${attachmentId}/download?token=${token}`,
        "_blank"
    );
};

export const getAssignableUsers = async () => {
    const response = await axiosInstance.get("/workflow/assignable-users");
    return response.data;
};

// ==================== PERMISSIONS ====================

export const getPermissions = async () => {
    const response = await axiosInstance.get("/workflow/permissions");
    return response.data;
};

export const getUserPermissions = async (userId) => {
    const response = await axiosInstance.get(`/workflow/permissions/${userId}`);
    return response.data;
};

export const createPermission = async (permissionData) => {
    const response = await axiosInstance.post("/workflow/permissions", permissionData);
    return response.data;
};

export const deletePermission = async (permissionId) => {
    const response = await axiosInstance.delete(`/workflow/permissions/${permissionId}`);
    return response.data;
};
